// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1L1Ar","row":"styles_row__3LKbk","noUnderline":"styles_noUnderline__2eT3I","infoText":"styles_infoText__9aMV8","headerIcon":"styles_headerIcon__1uYqF"};